import React from 'react';
import Logo from '../assets/pplogotext.png';
import {Link} from "react-router-dom";
import styles from './BottomBar.module.css';
import { useTranslation } from '../hooks/useTranslation';

// I don't like this. Going to make it so you just import the folder and can reference it that way from anywhere in the app.
import AnalyticsIcon from "../assets/icons/activity.svg"
import DashboardIcon from "../assets/icons/message-circle.svg"
import { IoIosAddCircleOutline } from "react-icons/io";
import SupportIcon from "../assets/icons/help-circle.svg"
import SettingsIcon from "../assets/icons/settings.svg"


export const BottomBar = ({ isWorkspaceRegisterOpen, setIsWorkspaceRegisterOpen, mobile }) => {
    const t = useTranslation();

    const handleToggle = () => {
        if (typeof setIsWorkspaceRegisterOpen === 'function') {
            setIsWorkspaceRegisterOpen(!isWorkspaceRegisterOpen);
        }
    };

    const handleClose = () => {
        if (typeof setIsWorkspaceRegisterOpen === 'function') {
            setIsWorkspaceRegisterOpen(false);
        }
    };

    return (
        <nav className={`${styles.sidebar} ${mobile ? styles.mobile : ''}`}>
            <div 
                className={`${styles.link} ${styles.toggle} ${isWorkspaceRegisterOpen ? styles.active : ''}`}
                onClick={handleToggle}
            >
                <IoIosAddCircleOutline className={`${styles.icon} ${styles.toggle}`} />
            </div>
            <Link className={styles.link} to="dashboard" onClick={handleClose}>
                <img className={styles.icon} alt="message-circle" src={DashboardIcon} />
                <span className={styles.text}>{t("Dashboard")}</span>
            </Link>
            <Link className={styles.link} to="analytics" onClick={handleClose}>
                <img className={styles.icon} alt="activity" src={AnalyticsIcon} />
                <span className={styles.text}>{t("Analytics")}</span>
            </Link>
            <a className={styles.link} href="https://pageparrot.com/support" target="_blank" rel="noopener noreferrer">
                <img className={styles.icon} alt="help-circle" src={SupportIcon} />
                <span className={styles.text}>{t("Support")}</span>
            </a>
            <Link className={styles.link} to="settings" onClick={handleClose}>
                <img className={styles.icon} alt="gear" src={SettingsIcon} />
                <span className={styles.text}>{t("Settings")}</span>
            </Link  >
        </nav>
    )
}